import React, { useState, useEffect, useRef } from 'react'
import { useOnViewport } from '../hooks'

export function withAnimateValue(WrappedComponent, minStep = 1){
  return function (props) {
    const { value, ...rest } = props
    const container = useRef()
    const step = useRef(null)
    const [onScreen, watchNode] = useOnViewport({once:true})
    const [current, setCurrent] = useState(0)
    const newValue = typeof value === 'number' ? current : value

    useEffect(()=>{
      if (typeof value === 'number'){
        step.current = Math.max(minStep, Math.abs(Math.max(0, value) - current) / 10)
      } else {
        step.current = null
      }
    }, [value])

    useEffect(()=>{
      let timeout = null
      if (!onScreen && step.current && current != value) watchNode(container.current)
      if (step.current && onScreen && current != value) {
        timeout = setTimeout(()=>{
          if (value > current){
            setCurrent(Math.min(value, current + step.current))
          } else {
            setCurrent(Math.max(value, current - step.current))
          }
        }, current == 0 ? 300 : 10)
      }   
      return () => timeout && clearTimeout(timeout)
    })

    return (<div ref={container} className={props.className}><WrappedComponent value={newValue} {...rest}/></div>)
  }
}

const AnimateValue = withAnimateValue((props) => props.value)

export default AnimateValue
